import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '@/vuetify'
import ElementUI from 'element-ui'

import VueAxios from 'vue-axios'
import axios from 'axios'

import 'vuetify/dist/vuetify.min.css'
import 'element-ui/lib/theme-chalk/index.css'
import LoginService from '@/service/user/LoginService'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(vuetify as any)
Vue.use(ElementUI)
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

LoginService.getLoginState()

new Vue({
  router,
  store,
  vuetify: vuetify,
  render: h => h(App)
}).$mount('#app')
